import styled from "styled-components";

export const ErrorMessageStyling = styled.span`
    font-size: 12px;
    color: red;
    font-family: RubikRegular;
    padding: 5px;
`;